import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'A dimension defining the cluster of spaces. Used to group spaces based on shared characteristics',
    name: 'Space Clusters',
    partialId: PartialId.Standard.create('space_clusters'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
